/* eslint-disable react/no-children-prop */
import { Grid, Typography } from '@material-ui/core';
import { useRootTranslation } from 'utils/hooks';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Text } from 'components/styleguide';

const rootT = 'drawers.importCommercialTracksDrawer';

const formatParams = (params) => {
  if (!params) return undefined;
  const formatted = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    formatted[key] = Array.isArray(value) ? value.join(', ') : value;
  });
  return formatted;
};

const errorMessageKey = (code, params) => {
  if (code === 'FILE_STRUCTURE_INVALID' && params && params.missingHeaders) {
    return 'errors.FILE_STRUCTURE_INVALID_headers';
  }
  return `errors.${code}`;
};

const ErrorOnSpreadsheet = ({ errors, onTryAgain }) => {
  const t = useRootTranslation(rootT);

  return (
    <Grid
      container
      xs={12}
      direction="column"
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      style={{ height: 'calc(100vh - 520px)', minHeight: 220 }}
    >
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1}>
        <ReportProblemIcon color="error" />
        <Text color="red" variant="formLabel" children={t('error.title')} bold />
      </Grid>
      {errors.map(({ code, params }) => (
        <Grid item alignContent="center" key={`${code}-${JSON.stringify(params)}`}>
          <Text variant="formLabel" children={t(errorMessageKey(code, params), formatParams(params))} />
        </Grid>
      ))}
      <Grid item style={{ marginTop: 24 }}>
        <div>
          <Typography
            variant="caption"
            data-testid="import-commercial-tracks-try-again"
            style={{
              textDecoration: 'underline',
              color: 'primary.main',
              cursor: 'pointer',
            }}
            children={t('error.tryAgain')}
            onClick={onTryAgain}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default ErrorOnSpreadsheet;
